var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletQRcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223,
    height: 225,
    viewBox: "0 0 223 225",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 28.0165H55.75V56.033H27.875V28.0165Z",
    fill: "#1F3048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.625 0V84.0495H0V0H83.625ZM69.6875 14.0082H13.9375V70.0412H69.6875V14.0082ZM55.75 168.099H27.875V196.115H55.75V168.099Z",
    fill: "#1F3048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.625 140.082V224.132H0V140.082H83.625ZM13.9375 154.091V210.124H69.6875V154.091H13.9375ZM167.25 28.0165H195.125V56.033H167.25V28.0165Z",
    fill: "#1F3048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.375 0V84.0495H223V0H139.375ZM209.062 14.0082V70.0412H153.312V14.0082H209.062ZM111.5 14.0082V0H125.438V28.0165H111.5V56.033H97.5625V14.0082H111.5ZM111.5 84.0495V56.033H125.438V84.0495H111.5ZM83.625 112.066V98.0577H97.5625V84.0495H111.5V112.066H125.438V98.0577H195.125V112.066H139.375V126.074H97.5625V112.066H83.625ZM83.625 112.066V126.074H27.875V112.066H13.9375V126.074H0V98.0577H41.8125V112.066H83.625ZM223 126.074H209.062V98.0577H223V126.074ZM209.062 126.074H195.125V154.091H223V140.082H209.062V126.074ZM153.312 126.074H181.188V140.082H167.25V154.091H153.312V126.074ZM181.188 168.099V154.091H167.25V168.099H153.312V182.107H125.438V196.115H167.25V168.099H181.188ZM181.188 168.099H223V182.107H195.125V196.115H181.188V168.099ZM125.438 154.091V168.099H139.375V140.082H97.5625V154.091H125.438Z",
    fill: "#1F3048"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5625 168.099H111.5V210.124H167.25V224.132H97.5625V168.099ZM223 196.115V224.132H181.188V210.124H209.062V196.115H223Z",
    fill: "#1F3048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletQRcode);
export default __webpack_public_path__ + "static/media/walletQRcode.a7256b1836abf090883f373a6da5c5e0.svg";
export { ForwardRef as ReactComponent };